import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import AddAuth from './edits/AddAuth';
import RemoveAuth from './edits/RemoveAuth';
import ResetPassword from './edits/ResetPassword';
import ReactivateAuth from './edits/ReactivateAuth';

import CaregiverStatus from './caregiver_status';

const CaregiverAuth = (props) => {
  const [model, setModel] = React.useState({});

  const caregiverAuth = props.caregiverAuth;
  const caregiverBackend = props.caregiverBackend;

  const parentReload = props.refresh;

  React.useEffect(() => {
    caregiverBackend.load.loadAuth();
  }, [parentReload]);

  const openDialogs = {
    close: () => {
      setModel({});
    },
    addAuth: () => {
      setModel({action: 'ADD_AUTH'});
    },
    removeAuth: () => {
      setModel({action: 'REMOVE_AUTH'});
    },
    resetPassword: () => {
      setModel({action: 'RESET_PASSWORD'});
    },
    reactivateAuth: () => {
      setModel({action: 'REACTIVATE_AUTH'});
    },
  };

  const edits = {
    addAuth: (email) => {
      caregiverBackend.auth.setupAuth(
          email.toLowerCase(),
          () => {
            openDialogs.close();
          },
      );
    },
    removeAuth: () => {
      caregiverBackend.auth.removeAuth(
          () => {
            openDialogs.close();
          },
      );
    },
    resetPassword: (password) => {
      caregiverBackend.auth.resetPassword(
          password,
          () => {
            openDialogs.close();
          },
      );
    },
    reactivateAuth: () => {
      caregiverBackend.auth.reactivateAuth(
          () => {
            openDialogs.close();
          },
      );
    },
  };

  const popModelGenerator = React.useCallback(() => {
    let popModel = null;
    if (model.action === 'ADD_AUTH') {
      popModel = <AddAuth
        onClose={openDialogs.close}
        addAuth={edits.addAuth}
      />;
    } else if (model.action === 'REMOVE_AUTH') {
      popModel = <RemoveAuth
        onClose={openDialogs.close}
        removeAuth={edits.removeAuth}
      />;
    } else if (model.action === 'RESET_PASSWORD') {
      popModel = <ResetPassword
        onClose={openDialogs.close}
        resetPassword={edits.resetPassword}
      />;
    } else if (model.action === 'REACTIVATE_AUTH') {
      popModel = <ReactivateAuth
        onClose={openDialogs.close}
        addAuth={edits.reactivateAuth}
      />;
    }
    return popModel;
  }, [model]);

  return (
    <Stack
      spacing={2}
      sx={{
        pb: 2,
      }}
    >
      {popModelGenerator()}
      <CaregiverStatus
        openDialogs={openDialogs}
        edits={edits}
        caregiverAuth={caregiverAuth}
      />
    </Stack>
  );
};

CaregiverAuth.propTypes = {
  refresh: PropTypes.number.isRequired,
  caregiverAuth: PropTypes.object,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CaregiverAuth);
